<!--
 * @Description: 客户下拉选择框
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-11 10:40:24
 * @LastEditors: mdb
-->
<template>
  <a-select
    v-model:value="data"
    style="width: 100%"
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="search"
    :placeholder="t('common.pleaseSelect')"
    @change="change"
  >
    <a-select-option v-for="item in optionPage" :key="item.arkCode" :cosId="item.customerName" :value="item.arkCode">{{
      item.arkCode ? `${item.customerName}(${item.arkCode})` : item.customerName
    }}</a-select-option>
  </a-select>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import { findCusNameRelByPage as findCusNameRelByPageFbu } from '@/api/gucangSales/businessRuleSetting'
import { findCusNameRelByPage as findCusNameRelByPageOFbu } from '@/api/overseasSales/businessRuleSetting'
import { debounce } from 'lodash-es'
import { useI18n } from 'vue-i18n'
import type { PropType } from 'vue'
import type { SelectProps } from 'ant-design-vue'
const { t } = useI18n()

const props = defineProps({
  value: {
    type: String || Array
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_ofbu'>,
    required: true
  }
})

// 函数枚举对象
const findCusNameRelByPage = {
  cos_fbu: findCusNameRelByPageFbu,
  cos_ofbu: findCusNameRelByPageOFbu
}

const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = defineEmits(['update:value', 'selectData'])
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
      searchTxt.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  if (optionPage.value) {
    const arr = optionPage.value.filter((item) => item.arkCode === value)
    emit('selectData', arr[0].cosId)
  }
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const search = debounce((txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  findCusNameRelByPage[props.appId]({
    pageNumber: pageNumber.value,
    pageSize: 100,
    content: searchTxt.value
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'CusSelect' }
</script>
